import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import api from '../../../../services/API';
import { converterColagemWord } from './documento';
import '../../../Loja/Regulamento/conteudo.css';
import './styles.css';

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['blockquote', 'link'],
    ['clean'],
  ],
};
const notificar = (tipo, mensagem) => toast[tipo](mensagem, {
  position: toast.POSITION.BOTTOM_CENTER,
});

export default function RegulamentoPainel() {
  const editorRef = useRef(null);
  const [conteudo, setConteudo] = useState('');
  const [salvo, setSalvo] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [erroCarga, setErroCarga] = useState(false);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    api.get('/api/regulamento/painel').then((response) => {
      if (!response || !response.data) throw new Error('Não foi possível carregar o regulamento.');
      const html = response.data.conteudo || '';
      setConteudo(html);
      setSalvo(html);
    }).catch(() => {
      setErroCarga(true);
      notificar('error', 'Não foi possível carregar o regulamento.');
    }).finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    if (carregando || erroCarga || !editorRef.current) return undefined;
    const editor = editorRef.current.getEditor();
    const handlePaste = (event) => {
      const clipboard = event.clipboardData;
      if (!clipboard) return;
      const converted = converterColagemWord(clipboard.getData('text/html'), clipboard.getData('text/plain'));
      if (!converted) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const selection = editor.getSelection() || { index: editor.getLength() - 1, length: 0 };
      if (selection.length) editor.deleteText(selection.index, selection.length, 'user');
      editor.clipboard.dangerouslyPasteHTML(selection.index, converted, 'user');
      editor.focus();
    };
    editor.root.addEventListener('paste', handlePaste, true);
    return () => editor.root.removeEventListener('paste', handlePaste, true);
  }, [carregando, erroCarga]);


  const alterado = conteudo !== salvo;

  const salvar = async () => {
    setEnviando(true);
    try {
      const response = await api.put('/api/regulamento', { conteudo });
      if (!response || !response.data || !response.data.conteudo) throw new Error();
      // Não substituir o estado do Quill pelo HTML reserializado pelo servidor.
      setSalvo(conteudo);
      notificar('success', 'Regulamento salvo.');
    } catch {
      notificar('error', 'Não foi possível salvar o regulamento.');
    } finally {
      setEnviando(false);
    }
  };
  return (
    <section className="regulamento-painel">
      <h5 className="f-black">Regulamento Smart</h5>
      {carregando ? <p>Carregando regulamento...</p> : erroCarga ? (
        <p>Não foi possível carregar o regulamento.</p>
      ) : (
        <>
          <div className="regulamento-painel-acoes">
            <button type="button" className="btn btn-success" onClick={salvar} disabled={enviando || !alterado}>
              {enviando ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
          <div className="regulamento-painel-editor">
            <ReactQuill ref={editorRef} theme="snow" value={conteudo} onChange={setConteudo} modules={modules} readOnly={enviando} />
          </div>
        </>
      )}
    </section>
  );
}
